import i18n from 'i18next';
// import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { config } from '../../utils';
import translations from './translations.json';

interface i18InitParams {
  language?: string;
  customHeaders?: { [key: string]: string } | (() => { [key: string]: string });
}

/**
 * Function that initializes i18n and manages all of the static config, the elements that rely on a react component can
 * be passed in when this function is called
 *
 * @param language - A string representing the language code
 * @param customHeaders - An object of strings with custom request headers, e.g. \{ 'x-ap-lang': 'en-GB' \},
 * can also be a function that returns the equivalent
 * @returns void
 */
export const i18nInit = ({ language = 'en-GB' }: i18InitParams): void => {
  // all the backend functionality is commented at the moment until the api is stable
  // const backend = {
  //   loadPath: config.API_URL,
  //   allowMultiLoading: false,
  //   customHeaders,
  // };

  i18n
    // .use(HttpApi)
    .use(initReactI18next)
    .init({
      // backend,
      lng: language, // the language to set it to on initialisation
      fallbackLng: 'en-GB',
      // load: 'currentOnly',
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      resources: translations,
      ns: ['ns'],
      defaultNS: 'ns',
      debug: config.ENV === 'development',
      returnObjects: false,
      nsSeparator: '.',
      keySeparator: false,
    });
};
